module.exports = __webpack_public_path__ + "img/131.5dc94205.svg";